
<template>

<v-container>

    <v-row class="justify-center">

        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA')">
            <v-card to="/usuarios">
                <v-card-title>
                    Usuarios
                </v-card-title>
                <v-card-text class="text--primary">
                    /Usuarios
                </v-card-text>
            </v-card>
        </v-col>
        
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('CON')  ">
            <v-card to="/Proyecto">
                <v-card-title>
                    Proyecto
                </v-card-title>
                <v-card-text class="text--primary">
                    /Proyecto
                </v-card-text>
            </v-card>
        </v-col>
        
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('CON') || getRolesUsuario.includes('TALL') ">
            <v-card to="/Requisicion">
                <v-card-title>
                    Requisiciones
                </v-card-title>
                <v-card-text class="text--primary">
                    /Requisiciones
                </v-card-text>
            </v-card>
        </v-col>
        
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('TALL')">
            <v-card to="/pedidos">
                <v-card-title>
                    Pedidos
                </v-card-title>
                <v-card-text class="text--primary">
                    Pedidos
                </v-card-text>
            </v-card>
        </v-col>
        
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') ">
            <v-card to="/despiece">
                <v-card-title>
                    Despiece
                </v-card-title>
                <v-card-text class="text--primary">
                    /Despiece
                </v-card-text>
            </v-card>
        </v-col>
        
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') ">
            <v-card to="/OrdenesDeCompra">
                <v-card-title>
                    Órdenes de compra
                </v-card-title>
                <v-card-text class="text--primary">
                    Órdenes de compra
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('TALL') || getRolesUsuario.includes('MAQ') ">
            <v-card to="/maquinado">
                <v-card-title>
                    Maquinado
                </v-card-title>
                <v-card-text class="text--primary">
                    /maquinado
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('TALL') ">
            <v-card to="/salidaProcesos">
                <v-card-title>
                    Resguardo
                </v-card-title>
                <v-card-text class="text--primary">
                    /salidaProcesos
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('TALL') ">
            <v-card to="/checkin">
                <v-card-title>
                    Check-In
                </v-card-title>
                <v-card-text class="text--primary">
                    /checkin
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="4" v-if="getRolesUsuario.includes('TALL') ">
            <v-card to="/tareasProyectos">
                <v-card-title>
                    Tareas Proyectos
                </v-card-title>
                <v-card-text class="text--primary">
                    /tareasProyectos
                </v-card-text>
            </v-card>
        </v-col>
        
    </v-row>

</v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {

    computed: {
        ...mapGetters(['getRolesUsuario'])
    },
    created() {
        document.title = "Modulos | Bombas y Suministros del Norte"
    },
}
</script>

<style>

</style>